<template>
  <div id="users">
    <v-container v-if="!loading">
      <v-row>
        <v-col>
          <v-text-field
            class="rounded-xl"
            v-model="search"
            :outlined="!$store.state.site.whitelabel"
            append-icon="mdi-magnify"
            label="Search"
            @click:append="getUsers(true, true)"
            v-on:keyup.enter="getUsers(true, true)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="user in users.usersArray" :key="'user-' + user.id" md="3">
          <v-card class="rounded-xl" elevation="7">
            <v-container class="justify-center align-center">
              <div class="justify-center align-center text-center">
                <router-link
                  :to="'/u/' + user.username"
                  style="text-decoration: none"
                >
                  <v-avatar
                    v-if="user.avatar"
                    :src="'/i/' + user.avatar"
                    align="center"
                    class="text-center"
                    height="70"
                    width="70"
                  >
                    <img v-if="user.avatar" :src="'/i/' + user.avatar" />
                  </v-avatar>
                  <v-avatar
                    v-if="!user.avatar"
                    :src="'/api/v1/userutils/identicon/' + user.username"
                    align="center"
                    class="text-center justify-center"
                    justify="center"
                    size="70"
                  >
                    <img
                      v-if="!user.avatar"
                      :src="'/api/v1/userutils/identicon/' + user.username"
                    />
                  </v-avatar>
                </router-link>
              </div>
              <v-tooltip color="hoverCard" top>
                <template v-slot:activator="{ on }">
                  <v-card-title class="justify-center" v-on="on">
                    <v-icon
                      v-if="
                        user.plan.internalName !== 'FREE' &&
                        user.plan.internalName.indexOf('CSTM_TIER_') >= 0
                      "
                      :color="user.plan.color"
                      aria-hidden="false"
                    >
                      {{ user.plan.icon }}
                    </v-icon>
                    <v-icon
                      v-if="
                        user.administrator &&
                        user.plan.internalName.indexOf('CSTM_TIER_')
                      "
                      aria-hidden="false"
                      color="red"
                    >
                      mdi-gavel
                    </v-icon>
                    <v-icon
                      v-if="
                        user.plan.internalName !== 'FREE' &&
                        !user.administrator &&
                        !user.moderator &&
                        user.plan.internalName.indexOf('CSTM_TIER_')
                      "
                      :color="user.plan.color"
                      aria-hidden="false"
                    >
                      {{ user.plan.icon }}
                    </v-icon>
                    <span
                      v-if="
                        user.beta &&
                        user.plan.internalName === 'FREE' &&
                        !user.administrator &&
                        !user.moderator &&
                        user.plan.internalName.indexOf('CSTM_TIER_')
                      "
                      style="color: #764bc4"
                      >β</span
                    >
                    <v-icon
                      v-if="
                        user.moderator &&
                        !user.administrator &&
                        user.plan.internalName.indexOf('CSTM_TIER_')
                      "
                      aria-hidden="false"
                      color="green"
                    >
                      mdi-shield
                    </v-icon>
                    <router-link
                      :style="
                        'text-decoration: none; color:' +
                        calculateColor(user) +
                        ';'
                      "
                      :to="'/u/' + user.username"
                    >
                      <template
                        v-if="
                          user.moderator ||
                          user.administrator ||
                          user.plan.internalName.indexOf('CSTM_TIER_') ||
                          user.plan.internalName !== 'FREE'
                        "
                        >&nbsp;
                      </template>
                      {{ user.username }}
                    </router-link>
                  </v-card-title>
                </template>
                <div class="text-center">
                  <p class="text-h6">
                    <v-avatar
                      v-if="user.avatar"
                      :src="'/i/' + user.avatar"
                      align="center"
                      class="text-center"
                      height="40"
                      width="40"
                    >
                      <img v-if="user.avatar" :src="'/i/' + user.avatar" />
                    </v-avatar>
                    <v-avatar
                      v-if="!user.avatar"
                      :src="'/api/v1/userutils/identicon/' + user.username"
                      align="center"
                      class="text-center justify-center"
                      justify="center"
                      size="40"
                    >
                      <img
                        v-if="!user.avatar"
                        :src="'/api/v1/userutils/identicon/' + user.username"
                      /> </v-avatar
                    >&nbsp;{{ user.username }} (<span
                      style="
                        font-weight: 500;
                        background: -webkit-linear-gradient(#0179f3, #0190ea);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                      "
                      >{{ user.id }}</span
                    >)
                  </p>
                  <v-chip
                    v-if="
                      user.plan.internalName !== 'FREE' &&
                      user.plan.internalName.indexOf('CSTM_TIER_') >= 0
                    "
                    :color="user.plan.color"
                    class="ma-1"
                    text-color="white"
                  >
                    <v-icon> {{ user.plan.icon }}</v-icon
                    >&nbsp;
                    {{ user.plan.name }}
                  </v-chip>
                  <v-chip
                    v-if="user.administrator"
                    class="ma-1"
                    color="red"
                    text-color="white"
                  >
                    <v-icon> mdi-gavel</v-icon>&nbsp;Administrator
                  </v-chip>
                  <v-chip
                    v-if="user.moderator"
                    class="ma-1"
                    color="green"
                    text-color="white"
                  >
                    <v-icon> mdi-shield</v-icon>&nbsp;Moderator
                  </v-chip>
                  <v-chip
                    v-if="
                      user.plan.internalName !== 'FREE' &&
                      user.plan.internalName.indexOf('CSTM_TIER_')
                    "
                    :color="user.plan.color"
                    class="ma-1"
                    text-color="white"
                  >
                    <v-icon> {{ user.plan.icon }}</v-icon
                    >&nbsp;
                    {{ user.plan.name }}
                  </v-chip>
                  <v-chip
                    v-if="user.beta"
                    class="ma-1"
                    color="deep-purple"
                    text-color="white"
                  >
                    β Beta
                  </v-chip>
                </div>
              </v-tooltip>
              <div class="text-subtitle-1 text-center justify-center limit">
                {{ user.description }}
              </div>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="justify-center align-center text-center">
        <v-pagination
          v-model="page"
          :length="users.pager.endPage"
          :total-visible="7"
        ></v-pagination>
      </v-row>
    </v-container>
    <v-container v-else>
      <v-row>
        <v-col>
          <v-card class="rounded-xl" elevation="7">
            <v-container class="text-center">
              <p class="text-lg-h4">Loading...</p>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "Users",
  data() {
    return {
      page: 1,
      users: [],
      search: "",
      loading: true
    }
  },
  methods: {
    calculateColorHex(user) {
      if (user.admin && user.beta && user.premium) {
        return "#F44336"
      }
      if (user.admin && user.beta && !user.premium) {
        return "#F44336"
      }
      if (user.admin && !user.beta && user.premium) {
        return "#F44336"
      }
      if (user.admin && !user.beta && !user.premium) {
        return "#F44336"
      }
      if (!user.admin && user.beta && user.premium) {
        return "#3F51B5"
      }
      if (!user.admin && !user.beta && user.premium) {
        return "#3F51B5"
      }
      if (!user.admin && user.beta && !user.premium) {
        return "#673AB7"
      } else {
        return "#FFFFFF"
      }
    },
    calculateColor(user) {
      if (this.$vuetify.theme.dark) {
        return "#FFFFFF"
      } else {
        return "#000000"
      }
    },
    getUsers(init, resetPage) {
      if (resetPage) {
        this.page = 1
      }
      this.loading = true
      this.axios
        .get("/api/v1/user?page=" + this.page + "&search=" + this.search)
        .then((res) => {
          if (init) {
            this.users = res.data
          } else {
            this.users.push(res.data)
          }
          this.loading = false
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.getUsers(true)
  },
  watch: {
    page() {
      this.getUsers(true)
    }
  }
}
</script>

<style scoped>
.limit {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
